import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { ReactComponent as IconClose } from '../../../public/images/svg/icon_close.svg';
import Button from '../../Button/Button';
import TextArea from '../../TextArea/TextArea';
import { feedbackFormSchema } from '../../../schemas/feedback/form.schema';

const ModalForm = ({ text = '', isOpen = false, onClose, onSubmit }) => {
  const formik = useFormik({
    initialValues: { text },
    validationSchema: feedbackFormSchema,
    validateOnChange: false,
    validateOnBlur: true,
    validateOnMount: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      await onSubmit?.(values);
    }
  });

  if (!isOpen) {
    return null;
  }

  const handleClose = async () => {
    await formik.setFieldValue('text', text);
    onClose?.();
  };

  return (
    <div
      className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
      onClick={handleClose}
    >
      <div
        className="relative w-auto my-6 mx-auto max-w-3xl"
        onClick={(evt) => evt.stopPropagation()}
      >
        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex flex-col items-end justify-between mb-4">
            <button
              className="bg-transparent border-0 h-6 w-6 m-2 flex items-center justify-center"
              onClick={handleClose}
            >
              <IconClose />
            </button>
            <h2 className="w-full font-semibold flex flex-row justify-center text-xl">
              Please Leave Feedback
            </h2>
          </div>

          <form noValidate className="mx-6 w-96 flex flex-col">
            <TextArea
              id="text"
              value={formik.values?.text}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
              dataTest="feedback-form-text"
              error={formik.touched?.text && formik.errors?.text}
              bottomMarginSizing={1}
            />

            <Button
              type="submit"
              name="feedback"
              className="w-fit self-center shadow-sm rounded-sm bg-purple-200 py-4 px-16 text-white font-bold font-sans text-base focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-default disabled:opacity-50"
              label="Leave Feedback"
              dataTest="feedback-form-submit-button"
              disabled={formik.isSubmitting}
              onClick={formik.handleSubmit}
            />
            <Button
              type="button"
              name="cancel"
              className="w-fit self-center shadow-sm rounded-sm bg-transparent py-4 px-16 text-purple-200 font-bold font-sans text-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-default disabled:opacity-50"
              label="Cancel"
              dataTest="feedback-form-cancel-button"
              onClick={handleClose}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

ModalForm.propTypes = {
  text: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func
};

export default ModalForm;
